<template>
  <div class="flex max-w-7xl mx-auto px-4 md:pt-12 pt-0 md:pb-8">
    <article class="theme-page-content flex-1">
      <h1 class="pb-2 mb-0">{{ courseDisplayHeading }}</h1>
      <PageTemplateRenderer
        :content="course"
        type="course"
      />
    </article>
    <slot name="sidebar" />
  </div>
</template>

<script>
import PageTemplateRenderer from '@/components/PageTemplateRenderer'
import useInterpolation from '@/composables/useInterpolation'
import { generateCourseLabel } from '@/utils/dataLabels'
import useFeatureFlags from '@/composables/useFeatureFlags'
import { TITLE_INTERPOLATIONS } from '@/constants/featureFlags'

export default {
  components: {
    PageTemplateRenderer,
  },
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { enableTitleInterpolations } = useFeatureFlags({
      enableTitleInterpolations: TITLE_INTERPOLATIONS,
    })
    const { getInterpolatedFieldValue } = useInterpolation()
    return {
      getInterpolatedFieldValue,
      enableTitleInterpolations,
    }
  },
  computed: {
    courseDisplayHeading() {
      return generateCourseLabel(this.course, undefined, {
        getInterpolatedFieldValue: this.enableTitleInterpolations
          ? this.getInterpolatedFieldValue
          : undefined,
        nameOnlyFallback: true,
      })
    },
  },
}
</script>
